// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-transactions-module__container___I_MKz {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./client/app/pages/spot-rewards/view/components/no-transactions/no-transactions.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `no-transactions-module__container___I_MKz`
};
export default ___CSS_LOADER_EXPORT___;
